module.exports = __webpack_public_path__ + "static/media/delete.89d13b64.svg";